var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraPanDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.525 6.25L22.5 12.5H32.5L27.525 6.25ZM42.5 17.5V27.5L48.75 22.525L42.5 17.5ZM12.5 17.5L6.25 22.525L12.5 27.5V17.5ZM32.5 32.5H22.5L27.525 38.75L32.5 32.5ZM50 0H5C2.25 0 0 2.25 0 5V40C0 42.75 2.25 45 5 45H50C52.75 45 55 42.75 55 40V5C55 2.25 52.75 0 50 0ZM50 40.025H5V4.975H50V40.025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPanDesktop);
export default __webpack_public_path__ + "static/media/camera_pan_desktop.4fd12e0a6e12dcf0e48afd80e7d818b0.svg";
export { ForwardRef as ReactComponent };